import React, { Fragment, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { authApi } from '../../../api/authApi'
import { routes } from '../../../constantes/routes'
import PalexLogo from '../../header/PalexLogoNegro'
import logoutIcon from '../../../assests/img/header-icons/logout.svg'
import HashLoader from 'react-spinners/HashLoader'

const HeaderPresentation = () => {
  const history = useHistory()
  const infoProfileContactHospitalPresentation = useSelector(
    (state) => state.infoProfileContactHospitalPresentation,
  )

  const dispatch = useDispatch()
  const logout = () => dispatch(authApi.logout())

  useEffect(() => {}, [infoProfileContactHospitalPresentation])

  const logOut = () => {
    logout()
    history.push(routes.LANDING)
  }
  // console.log(infoProfileContactHospitalPresentation)
  return (
    <div className='header-presentation'>
      <div className='products__title__container'>
        <PalexLogo />
        {/* <button
          className='logout-presentation'
          onDoubleClick={() =>
            alert('me has descubierto (haz solamente un click para salir)')
          }
          onClick={() => logOut()}
        >
          <img className='navbar__icons' src={logoutIcon} alt='Salir'></img>
        </button> */}
      </div>
      <div className='products__title__container'>
        <h3 className='products__title'>Detalles de los documentos</h3>
      </div>
      {infoProfileContactHospitalPresentation.length > 0 ? (
        <Fragment>
          <table>
            <thead>
              <tr>
                <th>
                  <h4 className='products__sub'>Asunto</h4>
                </th>
                <th>
                  <h4 className='products__sub'>Contacto</h4>
                </th>
                <th>
                  <h4 className='products__sub'>Hospital</h4>
                </th>
                <th>
                  <h4 className='products__sub'>Delegado</h4>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: 'none' }}>
                <td>
                  <p className='products__text'>
                    {infoProfileContactHospitalPresentation.nombrePresentation}
                  </p>
                </td>
                <td>
                  <p className='products__text'>
                    {infoProfileContactHospitalPresentation.nombreContacto}
                  </p>
                </td>
                <td>
                  <p className='products__text'>
                    {infoProfileContactHospitalPresentation.hospitalContacto}
                  </p>
                  <p className='products__text-type'>
                    {infoProfileContactHospitalPresentation.poblacionHospital}
                  </p>
                </td>
                <td>
                  <p className='products__text'>
                    {infoProfileContactHospitalPresentation.nombreDelegado}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </Fragment>
      ) : // <HashLoader color='#0ca39d' />
      null}
    </div>
  )
}
export default HeaderPresentation
